export var RepeatStrategy;
(function (RepeatStrategy) {
    RepeatStrategy["Daily"] = "DAILY";
    RepeatStrategy["Weekly"] = "WEEKLY";
    RepeatStrategy["Monthly"] = "MONTHLY";
    RepeatStrategy["NoRepetition"] = "NO_REPETITION";
})(RepeatStrategy || (RepeatStrategy = {}));
